import { render, staticRenderFns } from "./CompaDetail.vue?vue&type=template&id=09d317ae&scoped=true"
import script from "./CompaDetail.vue?vue&type=script&lang=js"
export * from "./CompaDetail.vue?vue&type=script&lang=js"
import style0 from "./CompaDetail.vue?vue&type=style&index=0&id=09d317ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d317ae",
  null
  
)

export default component.exports